import { render, staticRenderFns } from "./BankPaymentPage.vue?vue&type=template&id=dc81ef0c&scoped=true"
import script from "./BankPaymentPage.vue?vue&type=script&lang=js"
export * from "./BankPaymentPage.vue?vue&type=script&lang=js"
import style0 from "./BankPaymentPage.vue?vue&type=style&index=0&id=dc81ef0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc81ef0c",
  null
  
)

export default component.exports